import React, { useState, useEffect }  from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import TablaModal from './tablaModal';
//import imgSrcMAC from './img/LOGOTIPO_HOSPITALES_MAC_1.png';
//import imgSrc4 from './img/nav_bar.jpeg';

// ****** DataTable
import 'datatables.net-dt/css/dataTables.dataTables.css';  // Estilos de DataTable
import 'datatables.net';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
// Bootstrap
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import 'bootstrap-icons/font/bootstrap-icons.css';


DataTable.use(DT);
const TablaColaboradores = ({usuario, apiUrl}) => {
    const [mensajes, setMensajes] = useState();
    const [estatusSelected, setEstatusSelected] = useState("");
    const [observaciones, setObservaciones] = useState("");
    const [rowSelected, setRowSelected] = useState(null);
    const [idUsuario, setIdUsuario] = useState(0);
    // **** Modales
    const [idHoraSelected, setIdHoraSelected] = useState(0);
    // -- Aprobación
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);

    const handleShowModal = (IDHORA, ESTATUS, row, IDUSUARIO) => {
        setRowSelected(row);
        setIdHoraSelected(IDHORA);
        setEstatusSelected(ESTATUS);
        setIdUsuario(IDUSUARIO);
        setShowModal(true);
    }

    const obtenHorasColaborador = () => {
        var idJefe = 0
        // 1.- Sacar el NOEMPLEADO
        if(usuario.idPerfil === 4) {
            idJefe = usuario.NOEMPLEADO
        }
        else {
            idJefe = usuario.IDUSUARIO
        }
        // 2.- USar NOEMPLEADO para consultar todos los subordinados
        //*/
        axios.post(`${apiUrl}/horaslaboradas/obtenHorasJefe?token=${sessionStorage.getItem('token')}`, 
            {
                idPersonaJefe: usuario.IDUSUARIO,
                idPerfil: usuario.idPerfil
            })
            .then((objResponse) => {
                setMensajes(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error al recuperar las horas de tus colaboradores: ' + error.response.data)
            });
        //*/
    }

    useEffect(()=>{
        obtenHorasColaborador();
    }, [])

    const columns = [
        { data: 'IDHORA'},
        { data: 'NOMBRECOLABORADOR'},
        { data: 'NOMBREPROYECTO'},
        { data: 'FECHA'},
        { data: 'HORAS'},
        { data: 'ACTIVIDAD'},
        { data: 'ESTATUS_DEPTO'},
        { title: 'Opciones'},
        { data: 'NOMBRETAREA', visible: false },
        { data: 'NOMBREETAPA', visible: false },
        { data: 'OBSERVACIONES', visible: false },
    ];

    const languageOpt = {
        info: 'Mostrando página _PAGE_ de _PAGES_',
        infoFiltered: '(filtrados de un total de _MAX_ colaboradores encontrados)',
        lengthMenu: 'Mostrando _MENU_ registros por página',
        zeroRecords: 'Cero colaboradores encontrados con los filtros seleccionados',
        search: 'Buscar',
        infoEmpty: 'No se encontraron',
        emptyTable: 'Tabla vacía (sin registros)'
    }
    
    const options = {
        order: [[0, 'desc']], // Indica que la primera columna (índice 0) se ordene de manera descendente
        columnsDefs: [
            {
                //targets: 1, // Índice de la columna a la que le queremos dar ancho
                //width: '100%' // El ancho deseado para esa columna
            },
            {
                //targets: [9],
                //width: '100px',
            }
        ],
        language: languageOpt,
        responsive: true
    };

    const actualizarEstatusHora = () => {
        axios.post(`${apiUrl}/horaslaboradas/actualizarEstatusHorasJefe?token=${sessionStorage.getItem('token')}`,
            {
                idHora: idHoraSelected,
                observacionesEstatus: observaciones,
                estatusHorasLaboradas: estatusSelected,
                idJefeHora: usuario.IDUSUARIO,
                idUsuarioHora: idUsuario
            })
            .then((response) => {
                setShowModal(false);
                setObservaciones("");
                obtenHorasColaborador();
            })
            .catch((error)=>{
                alert("Hubo un error al intentar actualizar el estatus de las horas.");
            })
    }
    return(
        <div>
            {/* 
                ***** Modal para aprobar y rechazar las horas como jefe directo
            */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Está a punto de actualizar el estatus de la hora con id: <b><u>{idHoraSelected}</u></b> como  <b><u>{estatusSelected}</u></b>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TablaModal row={rowSelected} />
                    {
                        (estatusSelected !== 'DETALLE') ? 
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Control 
                                as="textarea" rows={2}
                                style={{ resize: 'none'}} 
                                placeholder='Introduce las observaciones para las horas seleccionadas' value={observaciones}
                                onChange={event=>{setObservaciones(event.target.value)}}
                            />
                        </Form.Group>
                        : ""
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    {
                        (estatusSelected !== 'DETALLE') ?
                        <Button variant={(estatusSelected ==='APROBADA') ? "success" : "danger" } onClick={actualizarEstatusHora}>
                            {(estatusSelected ==='APROBADA') ? "Guardar aprobación" : "Guardar rechazo" }
                        </Button>
                        :
                        ''
                    }
                </Modal.Footer>
            </Modal>
            <h3 style={{textAlign: 'center'}}>Aprobar horas de departamento</h3>
            <Container>
                <Row>
                    <Col>
                        <DataTable
                            columns={columns} 
                            data={mensajes}  
                            className="display"
                            options={options}
                            responsive={true}
                            slots={{
                                7: (data, row) => (
                                    <div>
                                        {/* 
                                            **** ver detalle hora
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Ver</strong> detalle de hora.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-default btn-sm bi bi-search"
                                                style={{marginRight: '1em'}}
                                                onClick={ () => {
                                                    handleShowModal(row.IDHORA, "DETALLE", row, row.IDUSUARIO);
                                                }}
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** aprobar hora
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Aprobar</strong> horas del colaborador.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn btn-success btn-sm bi bi-check-circle-fill"
                                                style={{marginRight: '1em'}}
                                                onClick={ () => {
                                                    handleShowModal(row.IDHORA, "APROBADA", row, row.IDUSUARIO);
                                                }}
                                                disabled={( row.ESTATUS_DEPTO === 'APROBADA') ? true : false}
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** rechazar hora
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Rechazar</strong> horas del colaborador.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn btn-danger btn-sm bi bi-x-circle-fill"
                                                onClick={ () => {
                                                    handleShowModal(row.IDHORA, "RECHAZADA", row, row.IDUSUARIO);
                                                }}
                                                disabled={(row.ESTATUS_DEPTO === 'APROBADA') ? true : false}
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                )
                            }}
                            >
                            <thead>
                                <tr>
                                    <th className="dt-orderable-asc">idHora</th>
                                    <th>Nombre colaborador</th>
                                    <th>Proyecto</th>
                                    <th>Fecha</th>
                                    <th>Cantidad de horas</th>
                                    <th>Actividades</th>
                                    <th>Estatus departamento</th>
                                </tr>
                            </thead>
                        </DataTable>
                    </Col>
                </Row>
            </Container>
            
        </div>
    )
}

export default TablaColaboradores;